"use strict";
module.exports = require('./en');



//////////////////
// WEBPACK FOOTER
// ./node_modules/date-names/index.js
// module id = 1006
// module chunks = 0